import styled from 'styled-components';

export default styled.div`
	--gap: var(--spacing-x-large);
	display: flex;
	flex-direction: column;
	padding: var(--gap);
	gap: var(--gap);

	hr:last-child {
		display: none;
	}
`;
